import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'
import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadRequestCategoryItemQuestionsAction,
  ILoadRequestCategoryItemQuestionsSuccessAction,
  ILoadRequestCategoryItemQuestionsErrorAction,
} from '../actions/load-request-category-item-questions'

export type RequestCategoryItemQuestionsAction =
  | ILoadRequestCategoryItemQuestionsAction
  | ILoadRequestCategoryItemQuestionsSuccessAction
  | ILoadRequestCategoryItemQuestionsErrorAction

const init = (state: IMobilityState, action: RequestCategoryItemQuestionsAction) => ({
  ...state,
  requestCategoryItemQuestions: {
    ...initialState.requestCategoryItemQuestions,
    status: action.status,
  },
})

const success = (state: IMobilityState, action: RequestCategoryItemQuestionsAction) => ({
  ...state,
  requestCategoryItemQuestions: {
    ...initialState.requestCategoryItemQuestions,
    status: action.status,
    items: (action as ILoadRequestCategoryItemQuestionsSuccessAction).items,
  },
})

const failure = (state: IMobilityState, action: RequestCategoryItemQuestionsAction) => ({
  ...state,
  requestCategoryItemQuestions: {
    ...initialState.requestCategoryItemQuestions,
    status: action.status,
    error: (action as ILoadRequestCategoryItemQuestionsErrorAction).error,
  },
})

export const serviceRequestCategoryItemQuestionsReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
)
